// extracted by mini-css-extract-plugin
export var container = "styles-module__container___RFs4n";
export var heading = "styles-module__heading___c1ISF";
export var headingText = "styles-module__headingText____4_CC";
export var innerContainer = "styles-module__innerContainer____Seee";
export var logoContainer = "styles-module__logoContainer____4T61";
export var onePercentLogo = "styles-module__onePercentLogo___f11gI";
export var orgContainer = "styles-module__orgContainer___Svn4p";
export var orgDesc = "styles-module__orgDesc___tv076";
export var orgIcon = "styles-module__orgIcon___tuQIK";
export var orgName = "styles-module__orgName___NFqol";
export var organizations = "styles-module__organizations___DSJiX";
export var subtitle = "styles-module__subtitle___gTwPv";
export var title = "styles-module__title___Zdvh7";
export var yellow = "styles-module__yellow____zQq8";